import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosPost } from '../../../utils/axios';
import { getFbTrackingPayload } from '../../../utils/fbTracking';
import * as actions from './actions';

function* createPendingNahual(action) {
  try {
    const result = yield call(AxiosPost, `/nahualchart/create_pending_reading/`, action.payload);
    yield put(actions.createPendingNahualSuccess(
      result.data.reading_id,
      result.data.nahual_label,
      result.data.signo_slug,
    ));
  } catch (e) {
    yield put(actions.createPendingNahualFailure(e));
  }
}

function* nahualCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/nahualchart/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.nahualCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.nahualCheckoutFailure(e));
  }
}

function* nahualPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/nahualchart/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.nahualPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.nahualPaypalOrderFailure(e));
  }
}

function* nahualVerify(action) {
  try {
    const result = yield call(AxiosPost, `/nahualchart/verify_purchase/`, action.payload);
    yield put(actions.nahualVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.nahualVerifyPurchaseFailure(e));
  }
}

function* nahualVerifyPaypal(action) {
  try {
    const result = yield call(AxiosPost, `/nahualchart/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.nahualVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.nahualVerifyPaypalFailure(e));
  }
}

export default function* nahualChartSaga() {
  yield all([
    takeLatest(actions.CREATE_PENDING_NAHUAL_REQUEST, createPendingNahual),
    takeLatest(actions.NAHUAL_CHECKOUT_REQUEST, nahualCheckout),
    takeLatest(actions.NAHUAL_PAYPAL_REQUEST, nahualPaypalOrder),
    takeLatest(actions.NAHUAL_VERIFY_REQUEST, nahualVerify),
    takeLatest(actions.NAHUAL_VERIFY_PAYPAL_REQUEST, nahualVerifyPaypal),
  ]);
}
